import React, { Component } from "react";

import { LoadScreen } from "../Common/LoadScreen";
import { DashboardJobs } from "./UI/DashboardJobs";
import { DashboardOrders } from "./UI/DashboardOrders";
import { DashboardProducts } from "./UI/DashboardProducts";
import { DashboardEvents } from "./UI/DashboardEvents";
import { DashboardTools } from "./UI/DashboardTools";
import * as pr from "../../common/PrimeComponents";
import { DashboardStationGuage } from "./UI/DashboardStationGuage";
import { DashboardIssues } from "./UI/DashboardIssues";
import { DashboardPrefab } from "./UI/DashboardPrefab";
import { DashboardPurchasing } from "./UI/DashboardPurchasing";
import { DashboardCoating } from "./UI/DashboardCoating";
export class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      loaded: true
    };
  }
  componentDidMount() {}

  render() {
    return (
      <div className="p-grid dashboard">
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <React.Fragment>
            <div className="ui-g-12">
              <div className="ui-g-4">
                <DashboardOrders />
              </div>
              <div className="ui-g-3">
                <DashboardJobs />
              </div>
              <div className="ui-g-5">
                <DashboardEvents />
              </div>
            </div>
            <div className="ui-g-12">
              <div className="ui-g-4">
                <DashboardProducts />
              </div>

              <div className="ui-g-2">
                <DashboardTools />
              </div>

              <div className="ui-g-3">
                <DashboardStationGuage />
              </div>
              <div className="ui-g-3">
                <DashboardIssues />
              </div>
            </div>
            <div className="ui-g-12">
              <div className="ui-g-4">
                <DashboardPrefab />
              </div>

              <div className="ui-g-4">
                <DashboardCoating />
              </div>

              <div className="ui-g-4">
                <DashboardPurchasing />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.js